document.addEventListener("DOMContentLoaded", function () {
    // Con `shopify theme dev` se usa la API local; en la web, la de producción.
    const API_BASE = ["127.0.0.1", "localhost"].includes(window.location.hostname)
        ? "http://localhost:82"
        : "https://api.zacaris.com";

    /** Escapa texto para poder pintarlo como HTML. */
    function escapeHtml(text) {
        const div = document.createElement("div");
        div.textContent = text;
        return div.innerHTML;
    }

    // Seleccionamos elementos del DOM
    const bubble = document.getElementById("chat-bubble");
    const widget = document.getElementById("chat-widget");
    const closeBtn = document.getElementById("chat-close");
    const sendBtn = document.getElementById("chat-send");
    const inputField = document.getElementById("chat-input");
    const messagesContainer = document.getElementById("chat-messages");

    // Si es una app, ocultamos el chat por defecto
    /*if (isApp()) {
      widget.style.display = "none";
      bubble.style.display = "none";
      return false;
    }*/

    /**
     * Obtiene el ID de la conversación desde localStorage, comprobando su expiración.
     * La sesión expira después de 3 horas.
     */
    function getConversationId() {
        const storedDataJSON = localStorage.getItem("y-chat-conversation-id");
        if (!storedDataJSON) {
            return "";
        }

        try {
            const storedData = JSON.parse(storedDataJSON);
            const now = new Date().getTime();
            const threeHoursInMillis = 3 * 60 * 60 * 1000;

            // Si no hay timestamp o si ha expirado, se limpia
            if (!storedData.timestamp || (now - storedData.timestamp > threeHoursInMillis)) {
                localStorage.removeItem("y-chat-conversation-id");
                return "";
            }

            return storedData.id;

        } catch (error) {
            // Si hay un error al parsear (formato antiguo), se limpia
            localStorage.removeItem("y-chat-conversation-id");
            return "";
        }
    }

    // Variable para mantener el conversation_id entre llamadas
    // Se intenta recuperar desde localStorage para persistir la sesión.
    let conversationId = getConversationId();

    // Estado para saber si el chat está abierto
    let isOpen = false;

    /**
     * Añade un mensaje de texto (user o assistant).
     * Usa clases prefijadas y-chat-message y y-chat-user / y-chat-assistant.
     */
    function addMessage(text, sender, isHtml = false, shouldScroll = true) {
        const msgDiv = document.createElement("div");
        msgDiv.classList.add("y-chat-message");
        if (sender === "assistant") {
            msgDiv.classList.add("y-chat-assistant");
        } else {
            msgDiv.classList.add("y-chat-user");
        }
        if (isHtml) {
            msgDiv.innerHTML = text;
        } else {
            msgDiv.textContent = text;
        }
        messagesContainer.appendChild(msgDiv);
        // Scroll automático hacia abajo solo si shouldScroll es true
        if (shouldScroll) {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }
        // Devolvemos el elemento del mensaje para poder añadirle elementos después
        return msgDiv;
    }

    /**
     * Tras un pulgar abajo, pregunta el motivo (opciones + comentario opcional).
     * La valoración negativa ya se ha guardado; esto solo la completa.
     */
    function showNegativeReasonUI(feedbackContainer, messageId, lang) {
        const texts = {
            es: { title: "¿Qué ha fallado?", placeholder: "Cuéntanos más (opcional)", send: "Enviar", thanks: "¡Gracias! Nos ayuda a mejorar." },
            en: { title: "What went wrong?", placeholder: "Tell us more (optional)", send: "Send", thanks: "Thanks! This helps us improve." },
            fr: { title: "Qu'est-ce qui n'a pas fonctionné ?", placeholder: "Dites-nous en plus (facultatif)", send: "Envoyer", thanks: "Merci ! Cela nous aide à nous améliorer." },
            it: { title: "Cosa non ha funzionato?", placeholder: "Raccontaci di più (facoltativo)", send: "Invia", thanks: "Grazie! Ci aiuta a migliorare." },
            de: { title: "Was ist schiefgelaufen?", placeholder: "Erzähl uns mehr (optional)", send: "Senden", thanks: "Danke! Das hilft uns, besser zu werden." },
            pt: { title: "O que correu mal?", placeholder: "Conte-nos mais (opcional)", send: "Enviar", thanks: "Obrigado! Isso ajuda-nos a melhorar." },
        };
        const reasons = {
            es: { not_understood: "No entendió mi pregunta", wrong_product: "Productos o tallas que no buscaba", wrong_info: "Información incorrecta", wants_human: "Prefiero hablar con una persona", unclear: "Respuesta confusa", other: "Otro" },
            en: { not_understood: "It didn't understand my question", wrong_product: "Products or sizes I wasn't looking for", wrong_info: "Incorrect information", wants_human: "I'd rather talk to a person", unclear: "Confusing answer", other: "Other" },
            fr: { not_understood: "Il n'a pas compris ma question", wrong_product: "Produits ou tailles non souhaités", wrong_info: "Information incorrecte", wants_human: "Je préfère parler à une personne", unclear: "Réponse confuse", other: "Autre" },
            it: { not_understood: "Non ha capito la mia domanda", wrong_product: "Prodotti o taglie che non cercavo", wrong_info: "Informazione errata", wants_human: "Preferisco parlare con una persona", unclear: "Risposta confusa", other: "Altro" },
            de: { not_understood: "Meine Frage wurde nicht verstanden", wrong_product: "Produkte oder Größen, die ich nicht suchte", wrong_info: "Falsche Information", wants_human: "Ich möchte lieber mit einer Person sprechen", unclear: "Unklare Antwort", other: "Sonstiges" },
            pt: { not_understood: "Não percebeu a minha pergunta", wrong_product: "Produtos ou tamanhos que não procurava", wrong_info: "Informação incorreta", wants_human: "Prefiro falar com uma pessoa", unclear: "Resposta confusa", other: "Outro" },
        };
        const t = texts[lang] || texts["es"];
        const r = reasons[lang] || reasons["es"];

        const panel = document.createElement("div");
        panel.classList.add("y-chat-feedback-reason");

        const title = document.createElement("span");
        title.classList.add("y-chat-feedback-reason-title");
        title.textContent = t.title;
        panel.appendChild(title);

        const options = document.createElement("div");
        options.classList.add("y-chat-feedback-reason-options");
        let selectedReason = null;

        const comment = document.createElement("textarea");
        comment.classList.add("y-chat-feedback-reason-comment");
        comment.placeholder = t.placeholder;
        comment.maxLength = 500;
        comment.rows = 2;

        const sendBtn = document.createElement("button");
        sendBtn.type = "button";
        sendBtn.classList.add("y-chat-feedback-reason-send");
        sendBtn.textContent = t.send;
        sendBtn.disabled = true;

        Object.keys(r).forEach(key => {
            const option = document.createElement("button");
            option.type = "button";
            option.classList.add("y-chat-feedback-reason-option");
            option.textContent = r[key];
            option.addEventListener("click", () => {
                selectedReason = key;
                options.querySelectorAll("button").forEach(b => b.classList.remove("y-chat-feedback-reason-selected"));
                option.classList.add("y-chat-feedback-reason-selected");
                sendBtn.disabled = false;
            });
            options.appendChild(option);
        });

        comment.addEventListener("input", () => {
            sendBtn.disabled = !selectedReason && comment.value.trim() === "";
        });

        panel.appendChild(options);
        panel.appendChild(comment);
        panel.appendChild(sendBtn);

        sendBtn.addEventListener("click", () => {
            sendBtn.disabled = true;

            fetch(`${API_BASE}/zacaris/Chats/addFeedback`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    conversation_id: conversationId,
                    message_id: messageId,
                    feedback: "negative",
                    reason: selectedReason || "other",
                    comment: comment.value.trim(),
                    lang: lang,
                }),
            })
                .then(response => {
                    if (!response.ok) {
                        console.error("Error al enviar el motivo del feedback a la API.");
                    }
                })
                .catch(error => {
                    console.error("Error en la llamada fetch del motivo del feedback:", error);
                })
                .finally(() => {
                    // Al cliente le basta con el agradecimiento, aunque falle el envío
                    panel.innerHTML = "";
                    const thanks = document.createElement("span");
                    thanks.classList.add("y-chat-feedback-reason-title");
                    thanks.textContent = t.thanks;
                    panel.appendChild(thanks);
                });
        });

        feedbackContainer.insertAdjacentElement("afterend", panel);

        setTimeout(() => {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }, 50);
    }

    /**
     * Añade la UI de feedback debajo de un elemento específico.
     * @param {HTMLElement} targetElement - El elemento después del cual se insertará el feedback.
     * @param {string} messageId - El ID del mensaje para la API.
     */
    function addFeedbackUI(targetElement, messageId, previousFeedback = null) {
        const feedbackContainer = document.createElement("div");
        feedbackContainer.classList.add("y-chat-feedback-container");

        // Texto traducido
        const feedbackText = document.createElement("span");
        feedbackText.classList.add("y-chat-feedback-text");
        let lang =
            window.Shopify && Shopify.locale
                ? Shopify.locale.toLowerCase().slice(0, 2)
                : "es";
        const translations = {
            es: "¿Te ha sido útil?",
            en: "Was this helpful?",
            fr: "Cela vous a-t-il été utile ?",
            it: "Ti è stato d'aiuto?",
            de: "War das hilfreich?",
            pt: "Isso foi útil?",
        };
        feedbackText.textContent = translations[lang] || translations["es"];

        // Contenedor para los botones
        const buttonsWrapper = document.createElement("div");
        buttonsWrapper.classList.add("y-chat-feedback-buttons");

        // Botón pulgar arriba
        const thumbUpBtn = document.createElement("button");
        thumbUpBtn.classList.add("y-chat-feedback-btn", "y-chat-thumb-up");
        thumbUpBtn.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" stroke-width="3" stroke="#000000" fill="none"><path d="M6.81,22.48V54.2h10.1a3.62,3.62,0,0,0,3.61-3.62V26.1a3.62,3.62,0,0,0-3.62-3.62Z"/><path d="M40.14,25.54a42.07,42.07,0,0,0,2-12.17c0-6.37-7-5.71-7-5.71s-2.85,14.6-14.6,18.77"/><path d="M33.59,25.59H54s2.64.23,2.64,3.58-2.53,3.36-2.53,3.36h-5.2"/><path d="M48.91,40H54s2.89,0,2.89-3.75S54,32.53,54,32.53"/><path d="M48.91,47.54H54s2.89,0,2.89-3.75S54,40,54,40"/><path d="M20.52,50.58l9.18,3s2.28.87,10.79.67,6.91-.14,9-.21c3.55,0,6.54-3.73,2.41-6.45"/></svg>`

        // Botón pulgar abajo
        const thumbDownBtn = document.createElement("button");
        thumbDownBtn.classList.add("y-chat-feedback-btn", "y-chat-thumb-down");
        thumbDownBtn.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17 1v2h-1.796l-2.47-.966L5.81 2a2.22 2.22 0 0 0-2.045 1.166 1.755 1.755 0 0 0-.062 1.425A2.15 2.15 0 0 0 2.65 5.939a2.19 2.19 0 0 0 .262 1.713 2.253 2.253 0 0 0-.923 1.461 2.165 2.165 0 0 0 .445 1.672 2.705 2.705 0 0 0-.523 2.564A2.084 2.084 0 0 0 3.85 15h3.39c.242 0 .56 0 .8.015a4.966 4.966 0 0 0-1.242 3.153c0 2.194.42 3.457 1.284 3.861a1.363 1.363 0 0 0 .58.126 2.013 2.013 0 0 0 1.213-.46l.179-.151v-.232a7.073 7.073 0 0 1 1.174-3.496 8.993 8.993 0 0 1 2.49-2.649L16.04 12H17v2h5V1zm0 10h-1.473l-2.448 3.395a9.933 9.933,0 0 0-2.683 2.867 8.134 8.134 0 0 0-1.328 3.772.658.658 0 0 1-.562.09c-.166-.08-.708-.521-.708-2.956a4.09 4.09 0 0 1 1.101-2.614 1.051 1.051 0 0 0 .237-1.06C8.886 14 8.266 14 7.24 14H3.85c-.524 0-.847-.48-.976-.928a1.616 1.616 0 0 1 .556-1.821l.582-.363-.525-.443a1.27 1.27 0 0 1-.508-1.175 1.359 1.359 0 0 1 .892-1.013l.747-.305-.604-.533a1.208 1.208 0 0 1-.395-1.227 1.167 1.167 0 0 1 .908-.851l.775-.167-.485-.628a.858.858 0 0 1-.153-.939A1.25 1.25 0 0 1 5.811 3h6.646l2.472.966L17 3.993zm4 2h-3V2h3z"/><path fill="none" d="M0 0h24v24H0z"/></svg>`

        buttonsWrapper.appendChild(thumbUpBtn);
        buttonsWrapper.appendChild(thumbDownBtn);

        feedbackContainer.appendChild(feedbackText);
        feedbackContainer.appendChild(buttonsWrapper);

        // Insertar el contenedor de feedback DESPUÉS del elemento de destino
        targetElement.parentNode.insertBefore(feedbackContainer, targetElement.nextSibling);


        // Forzar scroll hacia abajo para que el feedback sea visible
        setTimeout(() => {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }, 50);

        // Lógica para manejar el clic (ej: deshabilitar botones)
        const handleFeedbackClick = (e, feedbackType) => {
            thumbUpBtn.disabled = true;
            thumbDownBtn.disabled = true;

            // Añadir clase de opacidad a ambos botones
            thumbUpBtn.classList.add("y-chat-feedback-disabled");
            thumbDownBtn.classList.add("y-chat-feedback-disabled");

            // Añadir clase de seleccionado solo al que se hizo clic
            e.currentTarget.classList.add("y-chat-feedback-selected");

            // Payload para la API
            const feedbackPayload = {
                conversation_id: conversationId,
                message_id: messageId, // Usamos el ID del mensaje
                feedback: feedbackType, // 'positive' o 'negative'
                lang: window.Shopify && Shopify.locale ? Shopify.locale.toLowerCase().slice(0, 2) : "es",
            };

            if (feedbackType === 'negative') {
                showNegativeReasonUI(feedbackContainer, messageId, feedbackPayload.lang);
            }

            // Llamada AJAX para enviar el feedback
            fetch(`${API_BASE}/zacaris/Chats/addFeedback`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(feedbackPayload),
            })
                .then(response => {
                    if (!response.ok) {
                        console.error("Error al enviar el feedback a la API.");
                    }
                    // Cambiar texto a modo de confirmación para el usuario
                    const translations = {
                        es: "¡Gracias por tu valoración!",
                        en: "Thanks for your feedback!",
                        fr: "Merci pour votre évaluation !",
                        it: "Grazie per la tua valutazione!",
                        de: "Danke für dein Feedback!",
                        pt: "Obrigado pelo seu feedback!",
                    };
                    feedbackText.textContent = translations[feedbackPayload.lang] || translations["es"];
                })
                .catch(error => {
                    console.error("Error en la llamada fetch de feedback:", error);
                    // Igualmente, se puede dar una respuesta genérica
                    feedbackText.textContent = "Gracias.";
                });
        };

        thumbUpBtn.addEventListener("click", (e) => handleFeedbackClick(e, 'positive'));
        thumbDownBtn.addEventListener("click", (e) => handleFeedbackClick(e, 'negative'));

        // Respuesta ya valorada (al recuperar el historial): se enseña tal como quedó
        if (previousFeedback === 'positive' || previousFeedback === 'negative') {
            thumbUpBtn.disabled = true;
            thumbDownBtn.disabled = true;
            thumbUpBtn.classList.add("y-chat-feedback-disabled");
            thumbDownBtn.classList.add("y-chat-feedback-disabled");
            (previousFeedback === 'positive' ? thumbUpBtn : thumbDownBtn).classList.add("y-chat-feedback-selected");
            const thanks = {
                es: "¡Gracias por tu valoración!",
                en: "Thanks for your feedback!",
                fr: "Merci pour votre évaluation !",
                it: "Grazie per la tua valutazione!",
                de: "Danke für dein Feedback!",
                pt: "Obrigado pelo seu feedback!",
            };
            feedbackText.textContent = thanks[lang] || thanks["es"];
        }
    }

    /**
     * Carga el historial de un chat existente desde la API.
     * @param {string} id - El ID de la conversación a cargar.
     */
    async function loadChatHistory(id) {
        try {
            const response = await fetch(`${API_BASE}/zacaris/Chats/getHistory?conversation_id=${encodeURIComponent(id)}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });


            if (!response.ok) {
                // Si la API devuelve un error (ej: 404), la conversación no existe o ha expirado.
                // Limpiamos el ID local y mostramos el mensaje de bienvenida.
                localStorage.removeItem("y-chat-conversation-id");
                conversationId = "";
                showWelcomeMessage();
                return;
            }

            const data = await response.json();
            // La API devuelve { conversation_id, messages: [...] }; se admite también una lista suelta
            const history = Array.isArray(data) ? data : (data && Array.isArray(data.messages) ? data.messages : []);

            if (history.length > 0) {
                // Limpiar mensajes existentes antes de cargar el historial
                messagesContainer.innerHTML = '';

                history.forEach(msg => {
                    if (msg.role !== 'user' && msg.role !== 'assistant') {
                        return;
                    }

                    // Lo del cliente va siempre como texto; lo del asistente, en la versión que ya sanea la API
                    const msgElement = msg.role === 'assistant'
                        ? addMessage(normalizeBackendBreaks(msg.content_html || escapeHtml(msg.content || "")), "assistant", true)
                        : addMessage(msg.content || "", "user", false);

                    const messageId = msg.id || msg.message_id;
                    if (msg.role === 'assistant' && messageId) {
                        addFeedbackUI(msgElement, messageId, msg.feedback || null);
                    }
                });

                // Mostrar sugerencias después de cargar el historial
                showSuggestions();
            } else {
                // Si no hay historial, mostrar bienvenida
                showWelcomeMessage();
            }

        } catch (error) {
            console.error("Error al cargar el historial del chat:", error);
            // En caso de error de red, etc., mostrar bienvenida para no bloquear al usuario.
            showWelcomeMessage();
        }
    }

    /**
     * Renderiza un carrusel de productos en formato minimalista.
     * Envuelve el carousel en un wrapper que captura el scroll-x.
     * @returns {HTMLElement} El elemento del wrapper del carrusel.
     */
    function addProductCarousel(products) {
        // 1) Creamos el wrapper que controla el scroll-x
        const wrapper = document.createElement("div");
        wrapper.classList.add("y-chat-carousel-wrapper");
        wrapper.style.width = "calc(100% - 10px)"; // Pequeño ajuste para evitar overflow
        wrapper.style.maxWidth = "calc(100% - 10px)";

        // 2) Dentro del wrapper, creamos el carrusel propiamente dicho
        const carousel = document.createElement("div");
        carousel.classList.add("y-chat-product-carousel");

        // 3) Para cada producto, creamos su "item" minimalista
        products.forEach((product) => {
            const item = document.createElement("div");
            item.classList.add("y-chat-product-item");

            // Wrapper de imagen para badge
            const imgWrapper = document.createElement("div");
            imgWrapper.classList.add("y-chat-product-img-wrapper");
            // Añadir clase no-foto-nf solo si la imagen NO es del tipo "NF_X.jpg"

            /* let regex = /NF\d+/;
            if (!regex.test(product.image.url)) {
                imgWrapper.classList.add("no-foto-nf");
            } */

            // Imagen del producto
            const img = document.createElement("img");
            img.src = product.image;
            img.alt = product.image.altText || product.title;
            img.loading = "lazy";
            imgWrapper.appendChild(img);

            // Badge de descuento (si aplica)
            if (product.discount && product.discount > 0) {
                const badge = document.createElement("on-sale-badge");
                badge.setAttribute("discount-mode", "percentage");
                badge.classList.add("badge", "badge--on-sale");
                badge.textContent = `-${product.discount} %`;
                imgWrapper.appendChild(badge);
            }
            item.appendChild(imgWrapper);

            // Título del producto
            const title = document.createElement("div");
            title.classList.add("y-chat-product-title");
            title.textContent = product.title;
            item.appendChild(title);

            // Bloque de precios
            const priceContainer = document.createElement("div");
            priceContainer.classList.add("y-chat-product-price-block");

            if (product.discount && product.discount > 0) {
                // Precio oferta (rojo, grande) dentro de <sale-price>
                const oferta = document.createElement("sale-price");
                oferta.classList.add("h6", "text-on-sale");
                oferta.textContent = `${product.price.toFixed(2).replace(".", ",")} €`;
                priceContainer.appendChild(oferta);

                // Fila PVP
                const pvpRow = document.createElement("div");
                pvpRow.classList.add("y-chat-product-pvp-row");

                // PVP tachado (gris) en <compare-at-price>
                const pvp = document.createElement("compare-at-price");
                pvp.classList.add(
                    "h6",
                    "text-subdued",
                    "line-through",
                    "y-chat-product-pvp"
                );
                pvp.textContent = `${product.compareAtPrice
                    .toFixed(2)
                    .replace(".", ",")} €`;
                pvpRow.appendChild(pvp);

                priceContainer.appendChild(pvpRow);
            } else {
                // Solo precio normal en <sale-price> con clases h6 text-subdued
                const normal = document.createElement("sale-price");
                normal.classList.add("h6", "text-subdued");
                normal.textContent = `${product.price.toFixed(2).replace(".", ",")} €`;
                priceContainer.appendChild(normal);
            }
            item.appendChild(priceContainer);

            // Enlace "Ver más"
            const link = document.createElement("a");
            link.classList.add("y-chat-product-link", "button");
            link.href = product.url;
            link.target = "_blank";
            link.rel = "noopener";
            link.textContent = "Ver más";
            item.appendChild(link);

            // Añadimos el item al carrusel
            carousel.appendChild(item);
        });

        // 4) Insertamos el carrusel dentro del wrapper
        wrapper.appendChild(carousel);

        // 5) Finalmente, insertamos el wrapper en #chat-messages
        messagesContainer.appendChild(wrapper);

        // 6) Auto‐scroll vertical hacia abajo para que quede visible
        setTimeout(() => {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }, 100); // Pequeño delay para asegurar que se renderice

        return wrapper;
    }

    /**
     * Muestra el indicador de escritura
     */
    function showTypingIndicator() {
        // Verificar si ya existe para evitar duplicados
        if (document.querySelector(".y-chat-typing-indicator")) return;

        const typingDiv = document.createElement("div");
        typingDiv.classList.add("y-chat-typing-indicator");

        const typingText = document.createElement("span");
        typingText.classList.add("y-chat-typing-text");
        typingText.textContent = "";

        const dotsContainer = document.createElement("div");
        dotsContainer.classList.add("y-chat-typing-dots");

        // Crear los tres puntos animados
        for (let i = 0; i < 3; i++) {
            const dot = document.createElement("div");
            dot.classList.add("y-chat-typing-dot");
            dotsContainer.appendChild(dot);
        }

        // typingDiv.appendChild(typingText);
        typingDiv.appendChild(dotsContainer);
        messagesContainer.appendChild(typingDiv);

        // Scroll automático hacia abajo
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }

    /**
     * Oculta y elimina el indicador de escritura
     */
    function hideTypingIndicator() {
        const typingIndicator = document.querySelector(".y-chat-typing-indicator");
        if (typingIndicator) {
            typingIndicator.remove();
        }
    }

    // ---------------------------------
    // Funciones para abrir y cerrar el chat
    // ---------------------------------
    function openChat() {
        widget.style.display = "flex";
        isOpen = true;
        if (!widget.dataset.initiated) {
            if (conversationId) {
                // Si tenemos un ID, intentamos cargar el historial
                loadChatHistory(conversationId);
            } else {
                // Si no hay ID, mostramos el mensaje de bienvenida
                showWelcomeMessage();
            }
            widget.dataset.initiated = "true";
        }
    }

    /**
     * Muestra el mensaje de bienvenida inicial basado en el idioma.
     * @param {boolean} shouldScroll - Si debe hacer scroll automático al fondo (false para primera vez)
     */
    function showWelcomeMessage(shouldScroll = false) {
        // Detectar idioma
        let lang =
        window.Shopify && Shopify.locale
            ? Shopify.locale
            : navigator.language || navigator.userLanguage || "es";
        lang = lang.toLowerCase();
        let welcomeMsg = "";
        if (lang.startsWith("it")) {
            welcomeMsg =
            "Ciao! Sono <b>LOLA</b>, sono qui per aiutarti a trovare il look ideale, risolvere qualsiasi dubbio e rendere la tua esperienza su Yellow più facile e veloce.<br><br><b>Da dove cominciamo?</b> 😉";
        } else if (lang.startsWith("fr")) {
            welcomeMsg =
            "Bonjour ! Je suis <b>LOLA</b>, je suis là pour t'aider à trouver le look idéal, répondre à toutes tes questions et rendre ton expérience sur Yellow plus simple et rapide.<br><br><b>On commence par où ?</b> 😉";
        } else if (lang.startsWith("en")) {
            welcomeMsg =
            "Hi! I'm <b>LOLA</b>, I'm here to help you find the perfect look, answer any questions and make your experience on Yellow easier and faster.<br><br><b>Where shall we start?</b> 😉";
        } else if (lang.startsWith("pt")) {
            welcomeMsg =
            "Olá! Sou a <b>LOLA</b>, estou aqui para ajudar você a encontrar o look ideal, tirar qualquer dúvida e tornar sua experiência na Yellow mais fácil e rápida.<br><br><b>Por onde começamos?</b> 😉";
        } else if (lang.startsWith("de")) {
            welcomeMsg =
            "Hallo! Ich bin <b>LOLA</b>, ich bin hier, um dir zu helfen, den idealen Look zu finden, alle Fragen zu beantworten und deine Erfahrung bei Yellow einfacher und schneller zu machen.<br><br><b>Womit fangen wir an?</b> 😉";
        } else if (lang.startsWith("es")) {
            welcomeMsg =
            "¡Hola! Soy <b>LOLA</b>, estoy aquí para ayudarte a encontrar el look ideal, resolver cualquier duda y hacer que tu experiencia en Yellow sea más fácil y rápida.<br><br><b>¿Por dónde empezamos?</b> 😉";
        }

        addMessage(welcomeMsg, "assistant", true, shouldScroll);

        // Mostrar sugerencias después del mensaje de bienvenida
        showSuggestions(shouldScroll);
  }

    /**
     * Muestra sugerencias de mensajes según el idioma del usuario.
     * @param {boolean} shouldScroll - Si debe hacer scroll automático al fondo (false para primera vez)
     */
    function showSuggestions(shouldScroll = true) {
        // Detectar idioma
        let lang =
            window.Shopify && Shopify.locale
                ? Shopify.locale.toLowerCase().slice(0, 2)
                : "es";

        const suggestionsIconsSvg = {
            return: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path></svg>',
            track: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>',
            password: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>',
            search: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.35-4.35"></path></svg>',
            truck: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>'
        };

        // Definir sugerencias por idioma
        const suggestions = {
            es: [
                { icon: suggestionsIconsSvg.return, text: "Quiero devolver mi pedido" },
                { icon: suggestionsIconsSvg.track, text: "Estado de mi pedido" },
                { icon: suggestionsIconsSvg.password, text: "He olvidado mi contraseña" },
                { icon: suggestionsIconsSvg.search, text: "Buscar zapatillas deportivas" },
                { icon: suggestionsIconsSvg.track, text: "Estado de mi devolución" },
                { icon: suggestionsIconsSvg.truck, text: "Costes y envíos" }
            ],
            en: [
                { icon: suggestionsIconsSvg.return, text: "I want to return my order" },
                { icon: suggestionsIconsSvg.track, text: "Track my order" },
                { icon: suggestionsIconsSvg.password, text: "I forgot my password" },
                { icon: suggestionsIconsSvg.search, text: "Search for sneakers" },
                { icon: suggestionsIconsSvg.track, text: "Return status" },
                { icon: suggestionsIconsSvg.truck, text: "Shipping and costs" }
            ],
            fr: [
                { icon: suggestionsIconsSvg.return, text: "Je veux retourner ma commande" },
                { icon: suggestionsIconsSvg.track, text: "Suivre ma commande" },
                { icon: suggestionsIconsSvg.password, text: "J'ai oublié mon mot de passe" },
                { icon: suggestionsIconsSvg.search, text: "Rechercher des baskets" },
                { icon: suggestionsIconsSvg.track, text: "Statut de mon retour" },
                { icon: suggestionsIconsSvg.truck, text: "Frais et expéditions" }
            ],
            it: [
                { icon: suggestionsIconsSvg.return, text: "Voglio restituire il mio ordine" },
                { icon: suggestionsIconsSvg.track, text: "Traccia il mio ordine" },
                { icon: suggestionsIconsSvg.password, text: "Ho dimenticato la mia password" },
                { icon: suggestionsIconsSvg.search, text: "Cerca scarpe da ginnastica" },
                { icon: suggestionsIconsSvg.track, text: "Stato del mio reso" },
                { icon: suggestionsIconsSvg.truck, text: "Costi e spedizioni" }
            ],
            de: [
                { icon: suggestionsIconsSvg.return, text: "Ich möchte meine Bestellung zurücksenden" },
                { icon: suggestionsIconsSvg.track, text: "Bestellung verfolgen" },
                { icon: suggestionsIconsSvg.password, text: "Ich habe mein Passwort vergessen" },
                { icon: suggestionsIconsSvg.search, text: "Sneaker suchen" },
                { icon: suggestionsIconsSvg.track, text: "Rückgabestatus" },
                { icon: suggestionsIconsSvg.truck, text: "Versand und Kosten" }
            ],
            pt: [
                { icon: suggestionsIconsSvg.return, text: "Quero devolver meu pedido" },
                { icon: suggestionsIconsSvg.track, text: "Rastrear meu pedido" },
                { icon: suggestionsIconsSvg.password, text: "Esqueci minha senha" },
                { icon: suggestionsIconsSvg.search, text: "Procurar ténis" },
                { icon: suggestionsIconsSvg.track, text: "Status da minha devolução" },
                { icon: suggestionsIconsSvg.truck, text: "Envio e custos" }
            ]
        };

        const suggestionList = suggestions[lang] || suggestions["es"];
        
        // Obtener el título según el idioma
        const titles = {
            es: "Sugerencias:",
            en: "Suggestions:",
            fr: "Suggestions:",
            it: "Suggerimenti:",
            de: "Vorschläge:",
            pt: "Sugestões:"
        };
        const titleText = titles[lang] || titles["es"];

        // Crear el contenedor de sugerencias
        const suggestionsContainer = document.createElement("div");
        suggestionsContainer.classList.add("y-chat-suggestions-container");

        // Agregar título
        const title = document.createElement("div");
        title.classList.add("y-chat-suggestions-title");
        title.textContent = titleText;
        suggestionsContainer.appendChild(title);

        // Crear grid de sugerencias
        const grid = document.createElement("div");
        grid.classList.add("y-chat-suggestions-grid");

        suggestionList.forEach(suggestion => {
            const btn = document.createElement("button");
            btn.classList.add("y-chat-suggestion-btn");
            
            const icon = document.createElement("span");
            icon.classList.add("y-chat-suggestion-icon");
            icon.innerHTML = suggestion.icon;
            
            const text = document.createElement("span");
            text.classList.add("y-chat-suggestion-text");
            text.textContent = suggestion.text;
            
            btn.appendChild(icon);
            btn.appendChild(text);
            
            // Agregar evento click para enviar el mensaje
            btn.addEventListener("click", () => {
                inputField.value = suggestion.text;
                sendBtn.click();
            });
            
            grid.appendChild(btn);
        });

        suggestionsContainer.appendChild(grid);
        messagesContainer.appendChild(suggestionsContainer);

        // Scroll automático hacia abajo solo si shouldScroll es true
        if (shouldScroll) {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }
    }

    function isApp() {
        // Una cookie sin "=" (de un plugin, de la app…) no debe romper el chat
        return document.cookie.split(";").some(function (cookie) {
            return cookie.split("=")[0].trim() === "is_app";
        });
    }

    /**
     * Oculta y elimina las sugerencias del chat.
     */
    function hideSuggestions() {
        const suggestionsContainer = document.querySelector(".y-chat-suggestions-container");
        if (suggestionsContainer) {
            suggestionsContainer.remove();
        }
    }

    function closeChat() {
        widget.style.display = "none";
        isOpen = false;
    }

    // ---------------------------------
    // Event listeners
    // ---------------------------------

    // Lógica para ajustar la posición del chat cuando el teclado aparece en la app
    if (isApp()) {
        inputField.addEventListener('focus', () => {
            // Cuando el teclado se abre, pegamos el chat al fondo (elimina el espacio)
            widget.style.bottom = '0px';
            widget.style.transition = 'bottom 0.2s ease';
        });

        inputField.addEventListener('blur', () => {
            // Cuando el teclado se cierra, restauramos la posición original
            widget.style.bottom = '80px';
        });
    }

    // Alternar chat al hacer clic en la burbuja
    bubble.addEventListener("click", () => {
        if (isOpen) {
            closeChat();
        } else {
            openChat();
        }
    });

    // Cerrar al hacer clic en la “×”
    closeBtn.addEventListener("click", closeChat);

    // Enviar mensaje al hacer clic en enviar
    /** Idioma de la tienda en dos letras (es, en, fr…). */
    function chatLang() {
        return window.Shopify && Shopify.locale ? Shopify.locale.toLowerCase().slice(0, 2) : "es";
    }

    /**
     * Añade «Reintentar» a un mensaje de error: quita el error y el mensaje del
     * cliente y vuelve a enviar el mismo texto.
     */
    function showRetryButton(errorElement, text, userElement) {
        const labels = { es: "Reintentar", en: "Try again", fr: "Réessayer", it: "Riprova", de: "Erneut versuchen", pt: "Tentar novamente" };
        const retryBtn = document.createElement("button");
        retryBtn.type = "button";
        retryBtn.classList.add("y-chat-retry-btn");
        retryBtn.textContent = labels[chatLang()] || labels["es"];
        retryBtn.addEventListener("click", () => {
            if (inputField.disabled) return;
            errorElement.remove();
            if (userElement) userElement.remove();
            inputField.value = text;
            sendBtn.click();
        });
        errorElement.appendChild(document.createElement("br"));
        errorElement.appendChild(retryBtn);
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }

    sendBtn.addEventListener("click", () => {
        const text = inputField.value.trim();
        if (text === "") return;

        // Ocultar sugerencias cuando el usuario envía un mensaje
        hideSuggestions();

        // Deshabilitar input y botón
        inputField.disabled = true;
        sendBtn.disabled = true;

        // 1) Mostramos el mensaje del usuario
        const userMsgElement = addMessage(text, "user");
        inputField.value = "";

        // 2) Mostramos el indicador de escritura
        showTypingIndicator();

        // 3) Preparamos payload para la llamada POST
        // Obtener parámetros dinámicos desde el DOM o variables globales de Shopify
        const payload = {
            message: text,
            site: "yellowshop",
            country: window.Shopify && Shopify.country ? Shopify.country : "ES",
            lang: window.Shopify && Shopify.locale ? Shopify.locale : "es",
            conversation_id: conversationId,
        };

        // 4) Hacemos la petición a la API
        fetch(`${API_BASE}/zacaris/Chats/initChat`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then(async (response) => {
                if (response.ok) return response.json();
                // En los errores previstos (límite de uso, servicio parado…) la API manda su propio mensaje traducido
                const errorData = await response.json().catch(() => null);
                if (errorData && (errorData.message_html || errorData.message)) {
                    return { ...errorData, apiError: true };
                }
                throw new Error("Error en la respuesta de la API: " + response.status);
            })
            .then((data) => {
                // Ocultar el indicador de escritura
                hideTypingIndicator();

                if (data.apiError) {
                    const errorElement = addMessage(normalizeBackendBreaks(data.message_html || data.message), "assistant", true);
                    showRetryButton(errorElement, text, userMsgElement);
                    return;
                }

                // Actualizamos conversation_id si viene en la respuesta y lo guardamos con timestamp
                if (data.conversation_id && data.conversation_id !== conversationId) {
                    conversationId = data.conversation_id;
                    const conversationData = {
                        id: conversationId,
                        timestamp: new Date().getTime()
                    };
                    localStorage.setItem("y-chat-conversation-id", JSON.stringify(conversationData));
                }

                // Extraemos el messageId de la respuesta
                const messageId = data.message_id;

                // 5) Si vienen productos, mostramos primer texto y luego el carrusel envuelto
                if (Array.isArray(data.products) && data.products.length > 0) {
                    const assistantText = normalizeBackendBreaks(
                        data.message_html || data.message || "Estos productos podrían interesarte:"
                    );
                    const msgElement = addMessage(
                        assistantText,
                        "assistant",
                        true
                    );
                    const carouselElement = addProductCarousel(data.products, msgElement);
                    // Añadir UI de feedback después del carrusel
                    if (messageId) {
                        addFeedbackUI(carouselElement, messageId);
                    }
                } else {
                    // Si no hay productos, mostramos solo el mensaje de texto
                    const assistantText = normalizeBackendBreaks(
                        data.message_html || data.message || "Estos productos podrían interesarte:"
                    );
                    const msgElement = addMessage(
                        assistantText,
                        "assistant",
                        true
                    );
                    // Añadir UI de feedback solo si tenemos un messageId
                    if (messageId) {
                        addFeedbackUI(msgElement, messageId);
                    }
                }
            })
            .catch((error) => {
                // Ocultar el indicador de escritura también en caso de error
                hideTypingIndicator();
                console.error("Fetch error:", error);
                const errors = {
                    es: "No he podido conectar con el asistente. Revisa tu conexión e inténtalo de nuevo.",
                    en: "I couldn't reach the assistant. Check your connection and try again.",
                    fr: "Je n'ai pas pu joindre l'assistant. Vérifiez votre connexion et réessayez.",
                    it: "Non sono riuscita a contattare l'assistente. Controlla la connessione e riprova.",
                    de: "Der Assistent ist gerade nicht erreichbar. Prüfe deine Verbindung und versuche es erneut.",
                    pt: "Não consegui ligar ao assistente. Verifique a sua ligação e tente novamente.",
                };
                const errorElement = addMessage(errors[chatLang()] || errors["es"], "assistant");
                showRetryButton(errorElement, text, userMsgElement);
            })
            .finally(() => {
                // Volver a habilitar input y botón
                inputField.disabled = false;
                sendBtn.disabled = false;
                inputField.focus();
            });
    });

    // Permitir enviar mensaje al presionar Enter
    inputField.addEventListener("keyup", (event) => {
        if (event.key === "Enter") {
            sendBtn.click();
        }
    });

    // Cerrar chat al presionar Esc
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && isOpen) {
            closeChat();
        }
    });

    // ---------------------------------
    // Mensaje flotante sobre el bubble
    // ---------------------------------
    
    /**
     * Verifica si debe mostrarse el mensaje flotante
     * Retorna true si han pasado 15 días desde que se cerró
     */
    function shouldShowBubbleMessage() {
        const dismissedData = localStorage.getItem("y-chat-bubble-message-dismissed");
        if (!dismissedData) {
            return true; // Primera vez, mostrar
        }
        
        try {
            const dismissedTime = parseInt(dismissedData);
            const now = new Date().getTime();
            const fifteenDaysInMillis = 15 * 24 * 60 * 60 * 1000; // 15 días
            
            // Si han pasado más de 15 días, mostrar de nuevo
            return (now - dismissedTime) > fifteenDaysInMillis;
        } catch (error) {
            return true;
        }
    }

    function normalizeBackendBreaks(text) {
        if (typeof text !== "string") return text;
        return text.replace(/&lt;\s*br\s*\/?\s*&gt;/gi, "<br>");
    }
    
    /**
     * Muestra el mensaje flotante sobre el bubble
     */
    function showBubbleMessage() {
        if (!shouldShowBubbleMessage()) {
            return; // No mostrar si fue cerrado recientemente
        }
        
        // Detectar idioma
        let lang =
            window.Shopify && Shopify.locale
                ? Shopify.locale.toLowerCase().slice(0, 2)
                : "es";
        
        const messages = {
            es: "¡Hey! 👋 ¿Necesitas ayuda? ¡Estoy aquí para ti!",
            en: "Hey! 👋 Need help? I'm here for you!",
            fr: "Hey ! 👋 Besoin d'aide ? Je suis là pour toi !",
            it: "Hey! 👋 Hai bisogno di aiuto? Sono qui per te!",
            de: "Hey! 👋 Brauchst du Hilfe? Ich bin für dich da!",
            pt: "Ei! 👋 Precisa de ajuda? Estou aqui para você!"
        };
        
        const messageText = messages[lang] || messages["es"];
        
        // Crear el elemento del mensaje
        const bubbleMessage = document.createElement("div");
        bubbleMessage.id = "y-chat-bubble-message";
        bubbleMessage.classList.add("y-chat-bubble-message");
        
        const messageContent = document.createElement("div");
        messageContent.classList.add("y-chat-bubble-message-content");
        messageContent.textContent = messageText;
        
        const closeBtn = document.createElement("button");
        closeBtn.classList.add("y-chat-bubble-message-close");
        closeBtn.innerHTML = "&times;";
        closeBtn.setAttribute("aria-label", "Cerrar mensaje");
        
        bubbleMessage.appendChild(messageContent);
        bubbleMessage.appendChild(closeBtn);
        
        // Añadir al DOM
        document.body.appendChild(bubbleMessage);
        
        // Animar entrada después de un pequeño delay
        setTimeout(() => {
            bubbleMessage.classList.add("y-chat-bubble-message-show");
        }, 100);
        
        // Evento para cerrar el mensaje
        closeBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            bubbleMessage.classList.remove("y-chat-bubble-message-show");
            
            // Guardar timestamp de cierre en localStorage
            localStorage.setItem("y-chat-bubble-message-dismissed", new Date().getTime().toString());
            
            // Eliminar del DOM después de la animación
            setTimeout(() => {
                if (bubbleMessage.parentNode) {
                    bubbleMessage.parentNode.removeChild(bubbleMessage);
                }
            }, 300);
        });
        
        // Al hacer clic en el mensaje (no en el botón cerrar), abrir el chat
        messageContent.addEventListener("click", () => {
            // Cerrar el mensaje
            bubbleMessage.classList.remove("y-chat-bubble-message-show");
            setTimeout(() => {
                if (bubbleMessage.parentNode) {
                    bubbleMessage.parentNode.removeChild(bubbleMessage);
                }
            }, 300);
            
            // Guardar que fue usado
            localStorage.setItem("y-chat-bubble-message-dismissed", new Date().getTime().toString());
            
            // Abrir el chat
            if (!isOpen) {
                openChat();
            }
        });
    }
    
    // Mostrar mensaje flotante después de 7 segundos
    setTimeout(() => {
        showBubbleMessage();
    }, 7000);
});
